import { ClinicAuthError } from "@auth/clinicAuthClient";

export const RATE_LIMIT_ERROR = "Too many attempts. Please try again shortly.";
export const NETWORK_ERROR =
  "Could not reach the server. Check your connection.";
export const ACCOUNT_INACTIVE_ERROR = "This account is no longer active.";

/**
 * Map an auth failure to a user-facing message. Account deactivation,
 * rate-limit, and network cases are shared; everything else falls back to
 * `generic`, which each screen phrases for its own context (wrong clinic
 * password vs. wrong code/PIN).
 */
export const authErrorMessage = (err: unknown, generic: string): string => {
  const code = err instanceof ClinicAuthError ? err.code : "unknown";
  if (code === "account_inactive") return ACCOUNT_INACTIVE_ERROR;
  if (code === "rate_limited") return RATE_LIMIT_ERROR;
  if (code === "network_error") return NETWORK_ERROR;
  return generic;
};

/**
 * Whether another attempt could succeed. A deactivated account is terminal —
 * the screen should stop inviting retries instead of clearing the explanation
 * on the next keystroke. Lives here so the retry policy and the copy for a
 * code move together.
 */
export const isRecoverable = (err: unknown): boolean =>
  !(err instanceof ClinicAuthError && err.code === "account_inactive");
